<div [innerHTML]="this.content.summary | marked"></div>